import { render, staticRenderFns } from "./SignatureDialog.vue?vue&type=template&id=4275c7bf&scoped=true"
import script from "./SignatureDialog.vue?vue&type=script&lang=js"
export * from "./SignatureDialog.vue?vue&type=script&lang=js"
import style0 from "./SignatureDialog.vue?vue&type=style&index=0&id=4275c7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275c7bf",
  null
  
)

export default component.exports